export const gossipFaqs = [
  {
    question: "瓜料动态的「今日更新」多久刷新一次？",
    answer:
      "时间线在每天 00:00 重置为新的一个更新周期，编辑会在白天持续补充条目，重点话题出现进展时会优先置顶。晚上十点后若有新动态，也会照常收录，不会出现断档。",
  },
  {
    question: "这里的瓜料来源可靠吗？",
    answer:
      "我们只整理已经有一定公开讨论度、且能找到原始出处的内容，并在正文里说明信源层级。对于只有单一匿名截图、没有任何旁证的说法，会明确标注为「待确认」，不会当作事实呈现。",
  },
  {
    question: "为什么有的热点过几天就不再更新了？",
    answer:
      "一个话题的热度能否延续，取决于是否还有新的公开信息。如果后续只是重复已有内容，我们会在时间线里停止补充，避免制造无意义的热闹。你可以通过分类页回看已经沉淀下来的完整梳理。",
  },
  {
    question: "可以在瓜料动态上看到完整的前因后果吗？",
    answer:
      "可以。除了滚动的时间线，每一条重要动态都会有一篇成文的梳理，按时间顺序把背景、进展和目前的结论讲清楚，适合没跟上进度的读者快速补齐。",
  },
  {
    question: "订阅之后会收到什么内容？",
    answer:
      "订阅邮件会在每天固定时段汇总当天最重要的几条更新，附上简要说明和原文链接。我们不会发送与内容无关的推广，也不会把你的邮箱用于其他用途。",
  },
  {
    question: "瓜料动态会发布未经核实的消息吗？",
    answer:
      "不会。编辑流程要求每条内容在发布前至少确认信源类型，并在正文中标明。如果某个说法后来被证实有误，我们会在原页面更新说明，而不是悄悄删掉。",
  },
];